if (!customElements.get('orleone-edit-carousel')) {
  customElements.define('orleone-edit-carousel', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.resizeObserver?.disconnect();
      this.cleanup = new AbortController();
      const options = { signal: this.cleanup.signal };
      this.viewport = this.querySelector('.oe-carousel__viewport');
      this.pages = [...this.querySelectorAll('.oe-carousel__page')];
      this.previous = this.querySelector('[data-oe-prev]');
      this.next = this.querySelector('[data-oe-next]');
      this.counter = this.querySelector('[data-oe-current]');
      const controls = this.querySelector('.oe-carousel__controls');
      controls.hidden = this.pages.length < 2;
      this.setAttribute('data-ready', '');
      this.previous.addEventListener('click', () => this.go(this.index - 1), options);
      this.next.addEventListener('click', () => this.go(this.index + 1), options);
      this.viewport.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.viewport.addEventListener('keydown', event => {
        if (event.target !== this.viewport) return;
        let target;
        if (event.key === 'ArrowRight') target = this.index + 1;
        if (event.key === 'ArrowLeft') target = this.index - 1;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.pages.length - 1;
        if (target === undefined) return;
        event.preventDefault();
        this.go(target);
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.viewport);
      this.update();
    }

    update() {
      const width = this.viewport.clientWidth;
      if (!width || !this.pages.length) return;
      const gap = parseFloat(getComputedStyle(this.viewport).columnGap) || 0;
      this.index = Math.max(0, Math.min(this.pages.length - 1, Math.round(this.viewport.scrollLeft / (width + gap))));
      const value = String(this.index + 1);
      if (this.counter.textContent !== value) this.counter.textContent = value;
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.pages.length - 1;
    }

    go(index) {
      const target = this.pages[Math.max(0, Math.min(this.pages.length - 1, index))];
      if (!target) return;
      const left = target.offsetLeft - this.pages[0].offsetLeft;
      this.viewport.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    disconnectedCallback() {
      this.cleanup?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
